export default t => ({
  hidden: true,
  element: "bpmn:ErrorEventDefinition",
  service: "",
  title: t("script.controlls.errorEventDefinition.title"),
  helplink: "",
  class: "event",
  color: "#c42e33",
  icon_scale: 0.7,
  border: 4,
  icon: "anticon-icon edition-66",
  offset_x: 0,
  offset_y: -20,
  priority: 1,
  config: [
    {
      id: "commonSection",
      name: t("script.common.general"),
      type: "group"
    },
    {
      id: "description",
      name: t("script.common.description"),
      type: "text",
      readOnly: false,
      config: {
        type: "multiline",
        valueType: "const",
        map: "input"
      }
    },
    {
      id: "errorCode",
      name: t("script.controlls.errorEventDefinition.errorCodeIn"),
      type: "text",
      readOnly: false,
      config: {
        map: "outputErrorCode",
        theme: "script",
        placeholder: t("script.common.variable")
      }
    },
    {
      id: "errorMessage",
      name: t("script.controlls.errorEventDefinition.errorIn"),
      type: "text",
      readOnly: false,
      config: {
        map: "outputErrorMessage",
        theme: "script",
        placeholder: t("script.common.variable")
      }
    }
  ],
  exits: []
});
